import React from 'react';
import { 
    List, 
    Datagrid,
    TextField, 
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import DayDueCom from '../controls/DayToExpire'


const styles = {
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
};


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};



const DayExpire=({record})=>(
    <div>{record && record.day_to_exp < 0 ? <font color='red'><b>Overdue</b></font>: record && record.day_to_exp < 7 ? <font color='orange'>{record && record.day_to_exp}</font> : <font color='green'>{record && record.day_to_exp}</font>  }</div>
 )

const DayDue = ({record})=>{
 return (record.user_id > 0 && record.exam_id > 0) ? <DayDueCom record={record} /> : <div><font color='red'><b>Overdue</b></font></div>
}
  

export const TrainingList = ({ classes, permissions, ...props }) => (
  
    <List 
        classess={classes}
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        title="Employee Trainings"
        >
        
        <Datagrid  classes={{ headerCell: classes.header }} >     
            <TextField source="training_name"     label="Name" />
            <TextField source="full_name"     label="Employee" />
            <DayDue  label='Days to Expire' />
        </Datagrid>
    </List>

);


export default withStyles(listStyles)(TrainingList)